<template>
  <div
    class="w-100 d-flex flex-column content-wrap position-relative"
    :class="[ data.type.toLowerCase() + '-content-wrap', data.wrapClass, wrapClasses ]"
  >
    <graph-header
      :ind-override="indOverride"
      :data="sub"
      :bg="bg"
      :bot-held="botHeld"
      v-if="graphTypes.includes(data.type)"
    />
    <component
      :bg="bg"
      :data="contentData"
      :has-bot="(bot !== '')"
      :bot-held="botHeld"
      :ind-override="indOverride"
      :is="data.type"
      @enable-bot="botActive = true"
      @disable-bot="botActive = false"
      @toggle-ind="toggleInd"
      @activated.once="demoActive = demoBot"
      ref="content"
    />
    <span
      class="adobe-clean graph-desc centered-wrap"
      v-html="contentData.desc"
      v-if="contentData.desc && graphTypes.includes(data.type)"
    ></span>
    <adobot
      :bg="data.type.toLowerCase() === 'scatter' ? mainColor : bg"
      :active="botActive"
      :will-demo="demoBot"
      :demo-active="demoActive"
      @on="botOn"
      @off="botOff"
      v-if="bot"
    />
  </div>
</template>

<script>
  import ContentWrapMixin from '@/components/report/mixins/ContentWrapMixin'

  export default {
    name: 'ContentWrap',
    mixins: [ ContentWrapMixin ],
    props: { bg: { type: String, required: true } }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/global/the_goods";

  .content-wrap {
    padding : rem(60) $content-pad-x 0;

    &.px-0 .graph-copy {
      padding-left  : $content-pad-x;
      padding-right : $content-pad-x;
    }

    &.mobilemoment-content-wrap {
      padding-top    : rem(127);
      padding-bottom : rem(15);
      overflow       : visible;
    }

    &.vid, &.scatter, &.vidswitcher {
      &-content-wrap {
        padding-left  : 0;
        padding-right : 0;
      }
    }

    &.cluster-content-wrap {
      .graph-copy {
        padding-bottom : 0;
      }
    }

    &.scatter-content-wrap {
      .adobot-wrap {
        position  : absolute;
        z-index   : 10;
        bottom    : 32px;
        left      : 50%;
        transform : translateX(-50%);

        @include screen-lg-xl {
          bottom : 40px;
        }
      }

      .adobot-vect {
        position : static !important;
      }
    }

    &.venn-content-wrap {
      .adobot-wrap {
        margin-top : 0.5rem;
      }
    }

    &.vidswitcher-content-wrap {
      padding-top : 0;
      overflow    : initial;

      @include screen-md-lg-xl {
        padding : rem(100) 0;
      }
    }

    &:last-child {
      padding-bottom : rem(60);

      &.mobilemoment-content-wrap {
        padding-bottom : rem(71);
      }

      &.has-bot {
        padding-bottom : rem(25);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/ContentWrap.vue